import { Fields } from "../types/SchemaFactory";
import { TFunction } from "i18next";
import { schemaFactory } from "./SchemaFactory";
import { PriceForm } from "../domain/models/dto/PriceDTO";
import { getMaxEnumValue } from "../tools/EnumTools";
import { Currency } from "../domain/enums/CurrencyEnum";

export const priceFields: Fields<PriceForm> = {
    amount: {
        min: 1,
        max: {
            value: 999999,
            key: "workCreation.fields.max.price",
        },
        required: true,
        placeholderKey: "workCreation.fields.pricePlaceholder",
        type: "number",
        initial: null,
    },
    currency: {
        min: 1,
        max: getMaxEnumValue(Currency),
        required: true,
        placeholderKey: "",
        type: "number",
        initial: Currency.UAH,
    },
};

export const priceSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, priceFields);
};
